import styled from "styled-components";
import backImage from "../../../../assets/images/icons/back-logo.svg";
import topImage from "../../../../assets/images/icons/back-logo.svg";
import colors from "assets/scss/colors.scss";

const StyleWrapper = styled.div`

  .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
    border-radius: 12px;
    background: rgb(255, 255, 255) !important;
    border: 0 !important;
  }
  .set-accord {
  padding: 0;
  margin-bottom: 0.75rem;
  text-align: initial;
  }
  .policy-cover .p-accordion .p-accordion-header .p-accordion-header-link {
    border-radius: 12px;
    background: rgb(255, 255, 255) !important;
  display: block !important;
  padding: 0 !important;
  }
  .p-accordion-toggle-icon.pi {
  display: none;
  }
  .welcome-text {
    color: var(--text-black, #1A1C1F);
    /* Label En/S Label */
    font-family: Tawuniya;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 0.875rem; /* 100% */
  }
  .header-Text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 140px;
  }
  .head-icon {
  width: 8%;
  }
  .inner-content{

  }
  .Icon-Div{
  a{
  padding: 0 10px;
  }
  }
  .p-accordion-header.p-highlight{
  .Icon-Div{
  a{
    color: #6B47F5;
  }
  }
  }
  .up-acc {  color: ${colors["bright-purple"]}}
  .down-acc 
  color: #6B47F5 !important;
  }

  .p-accordion .p-accordion-content {
  padding: 24px !important;
  border-radius: 0px 0px 12px 12px !important;
  }
  .p-accordion
  .p-accordion-header:not(.p-disabled).p-highlight
  .p-accordion-header-link {
    border-radius: 12px;
  border-radius: 12px 12px 0px 0px !important;
  background: rgb(255, 255, 255) !important;
  }
  .header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  }
  .p-accordion .p-accordion-header .p-accordion-header-link {
    border-radius: 12px;
    background: rgb(255, 255, 255) !important;
    border-radius: 12px !important;
    display: block !important;
    padding: 0.7rem 0.5rem !important;

  }

}





.personal-details-head {
  background: #f2f3f5;
  box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
  border-radius: 12px;
  padding: 24px;
  text-align: initial;
  margin-bottom: 20px;
  h2 {
    font-weight: 800;
    font-size: 1.3rem;
    color: #4c565c;
  }
  h4 {
    font-weight: 800;
    font-size: 1rem;
    color: #4c565c;
    padding-left: 25px;
  }
  .username {
    display: flex;
  }
  .name {
    margin-top: 5px;
  }
  .pi {
    color: ${colors["bright-purple"]};
    display: inline-block;
    margin-right: 10px;
    margin-top: 3px;
  }
  i.pi.pi-user {
    border: 1px solid ${colors["bright-purple"]};
    border-radius: 50%;
    padding: 2px;
    margin-top: 1px;
    font-size: 13px;
  }
  p {
    font-weight: 400;
    font-size: 0.8rem;
    display: inline-block;
    color: #676f7c;
    margin-bottom: 3px;
    margin-top: -1px;
  }
  .rborder {
    border-right: 1px solid #c7c8c959;
    padding: 0 20px;
  }
}
.personal-details-head.ar {
  text-align: right;
  .rborder {
    border: none !important;
    border-left: 1px solid #c7c8c959;
  }

  h4 {
    padding-right: 35px;
  }
  .pi {
    margin-left: 10px;
  }
}

@media only screen and (max-width: 575.99px) {
  .personal-details-head {
    // display: none;
  }
  .rborder {
    padding: 0 !important;
  }
}
`;

export default StyleWrapper;
